import { Box, Link, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export const PendingEventWarning = () => {
  return (
    <Box>
      <Text textAlign={{ base: 'start', md: 'center' }}>
        Este evento não está liberado para vendas online. Para habilitar,
        vincule uma conta de repasse em{' '}
        <Link
          as={RouterLink}
          to="/me/events"
          mt={2}
          textDecoration="none"
          color="brand.500">
          Meus Eventos.
        </Link>
      </Text>
    </Box>
  );
};
